var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 2.75V21.25H11C11.4142 21.25 11.75 21.5858 11.75 22C11.75 22.4142 11.4142 22.75 11 22.75H4.6C3.85441 22.75 3.25 22.1456 3.25 21.4V2.6C3.25 1.85441 3.85442 1.25 4.6 1.25H16.2515C16.6095 1.25 16.9529 1.39223 17.2061 1.64541L20.3546 4.79393C20.6078 5.04711 20.75 5.39049 20.75 5.74853V12C20.75 12.4142 20.4142 12.75 20 12.75C19.5858 12.75 19.25 12.4142 19.25 12V6H16.6C16.2686 6 16 5.73137 16 5.4V2.75H4.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6C7.25 5.58579 7.58579 5.25 8 5.25H12C12.4142 5.25 12.75 5.58579 12.75 6C12.75 6.41421 12.4142 6.75 12 6.75H8C7.58579 6.75 7.25 6.41421 7.25 6Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 10C7.25 9.58579 7.58579 9.25 8 9.25H16C16.4142 9.25 16.75 9.58579 16.75 10C16.75 10.4142 16.4142 10.75 16 10.75H8C7.58579 10.75 7.25 10.4142 7.25 10Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H11C11.4142 13.25 11.75 13.5858 11.75 14C11.75 14.4142 11.4142 14.75 11 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 18C21.75 18.764 21.521 19.4753 21.1286 20.068L22.5303 21.4697C22.8232 21.7626 22.8232 22.2374 22.5303 22.5303C22.2374 22.8232 21.7626 22.8232 21.4697 22.5303L20.068 21.1286C19.4753 21.521 18.764 21.75 18 21.75C15.9289 21.75 14.25 20.0711 14.25 18C14.25 15.9289 15.9289 14.25 18 14.25C20.0711 14.25 21.75 15.9289 21.75 18ZM18 15.75C16.7574 15.75 15.75 16.7574 15.75 18C15.75 19.2426 16.7574 20.25 18 20.25C18.6226 20.25 19.1849 19.9981 19.5931 19.5889C19.9998 19.1811 20.25 18.6205 20.25 18C20.25 16.7574 19.2426 15.75 18 15.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageSearch);
export default __webpack_public_path__ + "static/media/page-search.e30a9ec7.svg";
export { ForwardRef as ReactComponent };